import React from 'react'

import {focusableClass, ensureFocusStyles} from '../UI/styles.js'
import {chip} from './styles.js'
import {describeQuery, operators} from './query.js'
import type {Query} from './types.js'

// The callers import the Query type from here
export type {Operator, Query} from './types.js'

ensureFocusStyles()

export interface SearchItemProps {
    query: Query
    onRemove: () => void
}

/** A search chip: column, operator and text. Clicking it (or Enter/Space when focused) removes the search. */
export default function SearchItem({query, onRemove}: SearchItemProps) {
    const operator = operators[query.operator]

    const operatorStyle: React.CSSProperties = {
        marginLeft: query.title === '' ? 0 : 5,
        marginRight: 6,
        fontSize: chip.operatorFontSize,
        color: chip.color,
        transform: 'translateY(1px)'
    }

    return (
        <button
            type='button'
            className={focusableClass}
            aria-label={`Zoekopdracht verwijderen: ${describeQuery(query)}`}
            style={{
                display: 'flex',
                alignItems: 'center',
                flexShrink: 0,
                cursor: 'pointer',
                font: 'inherit',
                border: 'none',
                background: chip.background,
                paddingLeft: chip.paddingX,
                paddingRight: chip.paddingX,
                height: chip.height,
                borderRadius: chip.radius,
                color: chip.color,
                boxShadow: chip.shadow
            }}
            onClick={onRemove}
        >
            {query.title}
            {operator?.icon ?
                <i aria-hidden style={operatorStyle} className={`mdi ${operator.icon}`} /> :
                <span aria-hidden style={operatorStyle}>{query.operator}</span>
            }
            {query.text}
            <i aria-hidden style={{marginLeft: 6, fontSize: 20, color: chip.color, transform: 'translateX(3px)'}} className='mdi mdi-close-circle' />
        </button>
    )
}
